module.exports = __webpack_public_path__ + "media/images/game/resources/satisfaction_small-4df6c891dc8753b1a5e7e0f08622e128.png";